require('dotenv').config();

export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const BASE_API_I18N_URL = process.env.REACT_APP_BASE_API_I18N_URL;
export const FACTORY = process.env.REACT_APP_FACTORY;
export const PRODUCT_CODE = process.env.PRODUCT_CODE || 'Admin';
// export const IFRAME_ZOHO_SRC          = process.env.IFRAME_ZOHO_SRC || 'https://desk.zoho.com/support/fbw?formType=AdvancedWebForm&fbwId=edbsn008bca2b99ffcc61a8e8b8141fa3cb3670ee4696462ac1159d10da02efa64e7d&xnQsjsdp=edbsn407cd7678526a9d3b42a3a2fb75e4811&mode=showNewWidget&displayType=iframe';